'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ = require('../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseModal = function CloseModal(props) {
  var _props$closeAfterClic = props.closeAfterClick,
      closeAfterClick = _props$closeAfterClic === undefined ? true : _props$closeAfterClic,
      closeModal = props.closeModal,
      onClick = props.onClick;

  var handleClick = function handleClick(e) {
    if (onClick) {
      onClick(e);
    }
    if (closeAfterClick) {
      closeModal(e);
    }
  };
  var buttonProps = Object.assign({}, props, {
    onClick: handleClick,
    className: (0, _classnames2.default)('luna-modal__close', [props.className])
  });
  return _react2.default.createElement(_.Button, buttonProps);
};

CloseModal.propTypes = {
  closeAfterClick: _propTypes2.default.bool,
  closeModal: _propTypes2.default.func,
  onClick: _propTypes2.default.func
};

exports.default = CloseModal;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Modal/ModalClose.js